import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';

const AppBreadcrumb = (props: any) => {
    const navigate = useNavigate();

    let items;

    if (!window.cn(props.currentMenu) || !window.cn(props.pageName)) {
        items = [{ label: props.currentMenu }, { label: props.pageName }];
    }

    return (
        <>
            <div className="layout-breadcrumb-container">
                <div className="layout-breadcrumb-left-items">
                    <h4 className="mb-0 flex align-items-center">
                        {!window.cn(props.goToPage) && props.goToPage === true && <Button icon="pi pi-arrow-left" className="p-button-secondary mr-2" onClick={() => navigate(-1)} />}
                        {!window.cn(props.pageTitle) && props.pageTitle}
                    </h4>
                    <BreadCrumb model={items} className="layout-breadcrumb" />
                </div>
            </div>
        </>
    );
};

export default AppBreadcrumb;
